import { Box, Stack, Typography, useTheme } from '@mui/material';
import { MessageSquare } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { H5, Small } from '../../components/Typography';
import AppAvatar from '../../components/avatars/AppAvatar';
import FlexBox from '../../components/flexbox/FlexBox';
import FlexRowAlign from '../../components/flexbox/FlexRowAlign';
import ToggleButton from './ToggleButton';

const data = [
  {
    id: 1,
    rank: 1,
    name: '홍길동',
    likes: 567,
    path: '/naver/callmetellme/mypage',
    avatar: '/static/avatar-photo/avatar-1.png',
  },
  {
    id: 2,
    rank: 2,
    name: '미어캣',
    likes: 331,
    path: '/naver/callmetellme/mypage',
    avatar: '/static/avatar-photo/avatar-2.png',
  },
  {
    id: 3,
    rank: 3,
    name: '김가루뿌링클',
    likes: 86,
    path: '/naver/callmetellme/mypage',
    avatar: '/static/avatar-photo/avatar-3.png',
  },
  {
    id: 4,
    rank: 4,
    name: '딸기쥬스',
    likes: 50,
    path: '/naver/callmetellme/mypage',
    avatar: '/static/avatar-photo/avatar-4.png',
  },
  {
    id: 5,
    rank: 5,
    name: '라이언',
    likes: 41,
    path: '/naver/callmetellme/mypage',
    avatar: '/static/avatar-photo/avatar-2.png',
  },
];

const tabs = [
  { id: '답변수', label: '답변수' },
  { id: '채택수', label: '채택수' },
  { id: '채택률', label: '채택률' },
];

const ReplyRanking = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState('답변수');
  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderRadius: '24px',
        padding: '20px',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
        border: '1px solid #f0f0f0',
      }}
    >
      <FlexBox
        sx={{
          alignItems: 'center',
          paddingBottom: '16px',
        }}
      >
        <img
          src={'/static/icons/medal.svg'}
          alt="money"
          style={{ width: '24px', height: '24px', marginRight: '8px' }}
        />
        <H5>답변 랭킹</H5>
      </FlexBox>

      <ToggleButton
        tabs={tabs}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
      {/* Stats list */}
      <Stack spacing={1} paddingTop={'16px'}>
        {data.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              cursor: 'pointer',
            }}
            onClick={() => navigate(item.path || '')}
          >
            <FlexRowAlign>
              <Small
                sx={{
                  fontSize: '16px',
                  color: theme.palette.primary.greytxt,
                  fontWeight: 500,
                  flex: 1,
                  marginRight: '4px',
                }}
              >
                {item.rank}
              </Small>
              <AppAvatar
                src={item.avatar}
                alt={item.name}
                style={{
                  width: '30px',
                  height: '30px',
                  marginRight: '8px',
                  backgroundColor: theme.palette.primary.grey700,
                }}
              />
              <Small
                sx={{
                  fontSize: '16px',
                  color: '#333333',
                  fontWeight: 500,
                  flex: 1,
                  marginRight: '12px',
                }}
              >
                {item.name}
              </Small>
            </FlexRowAlign>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Box marginRight={'4px'} marginTop={'4px'}>
                <MessageSquare
                  size={18}
                  color={theme.palette.primary.mainBlue}
                />
              </Box>
              <Typography
                sx={{
                  fontSize: '15px',
                  fontWeight: 500,
                  color: theme.palette.primary.mainBlue,
                }}
              >
                {item.likes}
              </Typography>
            </Box>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default ReplyRanking;
